import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const heroku = defineConnector({
  identifier: "heroku",
  name: "Heroku",
  tagLine: "Cloud platform as a service",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.heroku\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "Bearer",
      },
      {
        name: "Accept",
        value: "application/vnd.heroku+json; version=3",
      },
    ]),
  steps: [
    {
      title: "Get your Heroku API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the Heroku dashboard, go to **Account Settings > API Key** and reveal or regenerate your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.heroku.com/account",
  },
});
